"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtnLink = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../../helpers");
const BtnLink = props => {
    const { btnLabel, btnAction, iconLabel } = props;
    return (react_1.default.createElement(__1.DisableFocusWrapper, null,
        react_1.default.createElement(__1.TextCustom, { appearance: components_core_1.TokenTextAppearance.copy100, tag: components_core_1.TextTag.h2, style: {
                [helpers_1.Breakpoints.default]: {
                    fontSize: __1.TextSize.TextSize14,
                    lineHeight: __1.TextLineHeight.TextLineHeight16,
                    fontWeight: __1.TextWeight.bold
                },
                [helpers_1.Breakpoints.b1280]: {
                    fontSize: __1.TextSize.TextSize16,
                    lineHeight: __1.TextLineHeight.TextLineHeight20
                }
            } },
            react_1.default.createElement(__1.Link, { onClick: btnAction, isInline: true },
                btnLabel,
                " ",
                iconLabel || react_1.default.createElement(__1.ArrowRight, { variant: "small" })))));
};
exports.BtnLink = BtnLink;
